

<template>
  <div class="profile content-width">
    <h1>
      Sign up
    </h1>

    <FilmmakerDetailsForm
      ref="form"
      v-model="form"
    />

    <div style="text-align: right;">
      <el-button
        :loading="loading"
        type="primary"
        @click="submit"
      >
        Submit
      </el-button>
    </div>
  </div>
</template>

<script>
import webcall from '@/libs/webcall';
import FilmmakerDetailsForm from '../FilmmakerDetailsForm';

export default {
  components: {
    FilmmakerDetailsForm,
  },
  data() {
    return {
      form: {},
      loading: false,
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        .then(() => {
          this.loading = true;
          return webcall.user.filmmaker.create(this.form);
        })
        .then(() => this.$store.dispatch('account/initialiseAccount'))
        .then(() => {
          this.loading = false;
          this.$router.push('/signup/email');
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Profile/Signup/SignupFilmmaker.vue